import store from "../init/store.js";
import { setCrewValue } from "../redux-actions/battle-actions.js";
import { userRecordsSchema, addAcquisitionTypeToUser } from "../battle/connection/firebase-users.js";

export function loginFromOnboarding(userFirstName, callback: Function) {

  //First, update our local crew to include the user's entered firstname.
  const localCrew = store.getState().crew.members;
  const mainKey = Object.keys(localCrew)[0];
  setCrewValue({
    name: `${userFirstName}'s Crew`,
    record: { ...userRecordsSchema },
    members: {
      ...localCrew,
      [mainKey]: {
        ...localCrew[mainKey],
        name: userFirstName
      }
    }
  });

  //Now Log in to firebase, then set our initial crewMembers, Crew name, and record
  window.firebase
    .auth()
    .signInAnonymously()
    .catch(function(error) {
      console.warn("error", error); //
    })
    .then(function(user) {
      // console.log("user", user);

      //Set my local user id so we know I'm logged in.
      setCrewValue({
        logggedInUserId: user.uid
      });

      //Set all of my defaults to Firebase.
      const { name, record, members } = store.getState().crew;
      window.firebase
        .database()
        .ref(`users/client_${user.uid}`)
        .set({
          battleRecord: record,
          crewName: name,
          crewMembers: members
        })
        .then(function() {

          //Ready to proceed
          callback();

          //SIDE PROCESS: Add acquisition type to this user
          addAcquisitionTypeToUser(user.uid)
        });
    });
}



// WEBPACK FOOTER //
// ./src/b5-onboarding/loginFromOnboarding.js